<template>
  <div class="softskills-list">
    <div class="header">
      <div class="title">{{ $t(`student_modal.detail_${getText()}.title_${gender ? gender : 'u'}`, { firstname: capitalize(firstName) }) }}
      </div>
      <div class="sub-title">{{ $t(`student_modal.detail_${getText()}.subtitle_${gender ? gender : 'u' }`, { firstname: capitalize(firstName) }) }}</div>
    </div>
    <div>
      <div class="content">
        <div
          v-for="(softskill,index) in softskills"
          :id="softskill.id"
          ref="softskills"
          :key="softskill.id"
          :class="{ on: softskill.rated }"
          class="softskill"
          @click="selectSoftSkill(softskill, index)"
        >
          <div class="softskill-icon"><img :src="softskill.icon">&nbsp;&nbsp;{{ softskill.name }}</div>
          <div class="circle"/>
        </div>
      </div>
    </div>
    <div v-if="currentNote > 3" class="optionnal-text">
      {{ $t('student_modal.detail_soft_skills.optionnal_text') }}
    </div>
    <div class="next-button" @click="saveSoftSkills">
      <span v-if="currentNote < 4">Suivant</span>
      <span v-else>Envoyer</span>
      <IconArrowRight />
    </div>
  </div>
</template>

<script>

import IconArrowRight from '@/assets/icons/arrow-right.svg?component';

export default {
  name: 'studentSoftkillsModal',
  components: { IconArrowRight },
  props: ['softskills', 'initialData', 'firstName', 'currentNote', 'preloadSoftSkills', 'gender'],

  data() {
    return {
      selectedSoftskills: [],
    };
  },
  watch: {},
  mounted() {
    this.$emit('softskills-selected', this.selectedSoftskills);
    if (this.initialData && this.preloadSoftSkills) {
      this.selectedSoftskills = this.initialData;
      // eslint-disable-next-line no-confusing-arrow
      this.initialData.map((item) => document.getElementById(item.id) ? document.getElementById(item.id).classList.add('on') : null);
    }
  },
  methods: {
    getText() {
      if (this.currentNote === 5) {
        return 'favourite';
      }

      if (this.currentNote === 4) {
        return 'validated';
      }
      return 'notvalidated';
    },
    selectSoftSkill(softskill, index) {
      if (this.$refs.softskills[index].classList.contains('on')) {
        this.$refs.softskills[index].classList.remove('on');
        this.selectedSoftskills = this.selectedSoftskills.filter((item) => item.id !== softskill.id);
      } else {
        this.$refs.softskills[index].classList.add('on');
        this.selectedSoftskills.push(softskill);
      }
      this.$emit('softskills-selected', this.selectedSoftskills);
    },
    saveSoftSkills() {
      if (
        this.currentNote > 3
        || (this.selectedSoftskills && this.selectedSoftskills.length > 0)) {
        this.$emit('save-softskills', this.selectedSoftskills);
        return;
      }

      this.$notify.error({
        duration: 4000,
        title: this.$t('toast_message.notation.register_softskills_obligatory_bad_score.title'),
        message: this.$t('toast_message.notation.register_softskills_obligatory_bad_score.text'),
      });
    },
    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
  },
};
</script>

<style scoped>

</style>
